import React from 'react';
import { useSpring, animated } from 'react-spring';
import { MdError } from 'react-icons/md';
import { TiInfo } from 'react-icons/ti';
import { connect } from 'react-redux';

import { useAuth } from 'pages/Login/useAuth';
import Button from '../Button';
import { setCurrentUser } from 'redux/authentication/auth.actions';
import './alert.style.css'


const Alert = ({
  showModal,
  setShowModal,
  setCurrentUser,
  data
}) => {
  const { title, description, eventName, type } = data
  const auth = useAuth();

  const animation = useSpring({
    config: {
      duration: 250
    },
    opacity: showModal ? 1 : 0,
    transform: showModal ? `translateY(0%)` : `translateY(-100%)`
  });

  const clickHandler = () => {
    if (type === 'logout') {
      auth.removeToken();
      setCurrentUser(null);
    };
    if (type !== 'logout') setShowModal(prevState => ({ ...prevState, showModal: false }));
  };

  return (
    <>
      {showModal ? (
        <div className='alert-background'>
          <animated.div style={animation}>
            <div className='alert-wrapper'>
              <div className='alert-content'>
                {type !== 'info' && <MdError className='icon error' />}
                {type === 'info' && <TiInfo className='icon info' />}
                <h1 className={`${'header ' + type}`}>{title}</h1>
                <h2>{description}</h2>
                <Button
                  children={eventName}
                  onClick={clickHandler}
                />
              </div>
            </div>
          </animated.div>
        </div>
      ) : null}
    </>
  );
};

const mapDispatchToProps = dispatch => ({
  setCurrentUser: user => dispatch(setCurrentUser(user)),
});

export default connect(null, mapDispatchToProps)(Alert);